
export default {
    setPretensaoSalarial(state, data) {
        state.pretensaoSalarial = data
    },
    setPretensoesSalariais(state, data) {
        state.pretensoesSalariais = data
    }
}